module.exports = __webpack_public_path__ + "static/c1-29cfdb0f779c78bc0c5ab303d36a66a4.webp";